import React, { useContext, useEffect, useState } from 'react'
import Button from '../../../components/button/button'
import Modal from '../../../components/Modal/Modal'
import SignUpHandler from '../../../Apihander/signup/signupHandler'
import SidebarContext from '../../../contexts/MyContext'
import { useNavigate } from 'react-router-dom'
import moment from 'moment'
import { usePremiumStatus } from '../../../hooks/usePremiumStatus'
import '../../../css/accountSetting.css'
import { Icon } from "@iconify/react/dist/iconify.js";

const ManagePlan = () => {
    const { user, setPremiumLoading, premiumLoading, managePlanDetails, isWebUser, setIsWebUser, widgetLoaded, } = useContext(SidebarContext);
    const navigate = useNavigate()

    const [opnenModal, setOpenModal] = useState(false)
    const [subscribeUserDetails, setSubscibeUserDetails] = useState()
    const [loading, setLoading] = useState(false)
    const [isCancelSubscription, setIsCancelSubscription] = useState(false)
    const [billingCycle, setBillingCycle] = useState()
    const [planTitle, setPlanTitle] = useState()
    const [price, setPrice] = useState()
    const { startPolling } = usePremiumStatus();


    const features = [
        "Unlimited Premium & Standard Recording.",
        "Edit recordings with trimming and merging features.",
        "Unlimited Transcription of Recordings.",
        "Convert recordings into various formats.",
        "Convert recordings into various formats.",
        "Unlimited Secure Cloud Storage."
    ]

    const handleCancelSubscription = async () => {
        try {
            setLoading(true)
            const data = await SignUpHandler.doCancelSubscription()
            if (data) {
                // console.log(data, 'cancel subscription')
                setLoading(false)
                setOpenModal(false)
                setIsCancelSubscription(data?.isCancelSubscription)

            }
        } catch (error) {
            console.error(error, 'error cancel subscription')
            setLoading(false)

        }
    }

    const HandleGetSubscriptionDetails = async () => {
        try {
            const data = await SignUpHandler.doGetUserSubscriptionDetails()

            setSubscibeUserDetails(data?.subscriptions)

            // const subscriptionId = data?.subscriptions?.productId != "null" || 'N/A' ? data?.subscriptions?.productId : null;
            const subscriptionId = data?.subscriptions?.productId
            if (subscriptionId !== null && subscriptionId !== 'N/A') {
                const matchedPlan = managePlanDetails?.find((el) => el?.product_id === subscriptionId);
                if (matchedPlan) {
                    setIsWebUser(true);
                    const billingCycleResponse = matchedPlan?.billing_cycle;
                    setBillingCycle(billingCycleResponse)
                    const planTitleResponse = matchedPlan?.plan_title
                    setPlanTitle(planTitleResponse)
                    const priceResponse = data?.subscriptions?.amount === null || 'N/A'
                        ? matchedPlan.price || 'No Price Available'
                        : `₹${data?.subscriptions?.amount}`;
                    setPrice(priceResponse)
                } else {
                    console.log('No matching plan found');
                }
            }
            else {
                setIsWebUser(true);
                setBillingCycle('');
                const currencySymbols = {
                    USD: "$",
                    INR: "₹",
                    EUR: "€",
                    GBP: "£",
                    AUD: "A$",
                    CAD: "C$",
                    JPY: "¥"
                };
                const currencyCode = data?.subscriptions?.currency || 'USD'
                const currencySymbol = currencySymbols[currencyCode] || currencyCode;
                setPrice(`${currencySymbol}${data?.subscriptions?.amount}` || "No Plan Title Available");
                setPlanTitle(data?.subscriptions?.period ? `${data?.subscriptions?.period}` : "No Price Available");
            }
        } catch (error) {
            console.error(error, 'error cancel subscription')

        }
    }



    const isPlanActive = !subscribeUserDetails?.isCancelSubscription && !subscribeUserDetails?.isExpired && subscribeUserDetails?.isSubscriptionActive;

    const formattedExpireDate = moment(subscribeUserDetails?.expiresDate).format('DD, MMMM, YYYY');
    const formattedCancelSubDate = moment(subscribeUserDetails?.cancel_sub_at).format('DD, MMMM, YYYY');

    const createdDate = moment(subscribeUserDetails?.createdDate);
    const expiresDate = moment(subscribeUserDetails?.expiresDate);
    // const billingCycle = expiresDate.diff(createdDate, 'months') >= 12 ? 'Yearly' : 'Monthly';



    const openWidget = () => {
        if (widgetLoaded && window.FreshworksWidget) {
            window.FreshworksWidget('open');
            setOpenModal(false)
        } else {
            console.error('Widget is not loaded yet.');

        }
    };

    useEffect(() => {
        if (managePlanDetails) {
            HandleGetSubscriptionDetails();
        }
    }, [managePlanDetails]);


    return (
        <>
            <div className='vr-set-page'>
                <h2 className="vr-set-title">
                    Manage Plan
                </h2>
                {!user?.isSubscriptionActive && !user?.hasSubscribe && subscribeUserDetails?.status == "SUCCESS"
                    && (
                        <>
                            <p className='manage-sub-heading vr-set-banner-title'>No Active Subscription</p>
                            <div className='vr-set-banner'>
                                <p>No active subscription found. Choose a plan to get started!</p>
                                <button
                                    type="submit"
                                    className='vr-btn vr-btn-primary vr-btn-lg'
                                    onClick={() => navigate('/pricing')}
                                >
                                    Subscribe Now
                                </button>

                            </div>

                        </>

                    )
                }
                {!subscribeUserDetails?.isSubscriptionActive && user?.hasSubscribe && (
                    <>
                        <div className='vr-set-banner'>
                            {/* Check if the subscription has expired */}
                            {subscribeUserDetails?.isExpired && (
                                <p className='manage-sub-heading'>
                                    {`Your plan has been expired on ${formattedExpireDate}.`}
                                </p>
                            )}
                            {/* Check if the subscription is canceled */}
                            {subscribeUserDetails?.isCancelSubscription && (
                                <p className='manage-sub-heading'>
                                    {`Your plan will change to Free on ${formattedExpireDate}.`}
                                </p>
                            )}
                            <button
                                type="submit"
                                className='vr-btn vr-btn-primary vr-btn-lg'
                                onClick={() => navigate('/pricing')}
                            >
                                Reactivate
                            </button>
                        </div>
                    </>
                )}



                {/* Separate case for active subscription with canceled status */}
                {(user?.isSubscriptionActive || subscribeUserDetails?.isSubscriptionActive) && subscribeUserDetails?.isCancelSubscription && (
                    <div className='vr-set-banner'>
                        <p className='manage-sub-heading'>
                            {`Your plan is active but will be canceled on ${formattedCancelSubDate}.`}
                        </p>
                        <button
                            type="submit"
                            className='vr-btn vr-btn-primary vr-btn-lg'
                            onClick={() => navigate('/pricing')}
                        >
                            Reactivate
                        </button>
                    </div>
                )}



                {/* <div>
                    <p style={{ marginBottom: '10px', color: '#334155', fontWeight: '600', fontSize: '20px', flexDirection: 'row', display: 'flex', marginTop: '10px', fontFamily: 'Metropolis' }}>Current Plan</p>
                    
                </div> */}
                <div className='vr-set-card vr-set-plan'>
                    <div className='vr-set-plan-hero'>
                        <div className='vr-set-plan-top'>
                            <span className='vr-set-plan-icon'><Icon icon="lucide:crown" width="20" height="20" /></span>
                            {isPlanActive && <span className='vr-set-plan-status'>Active</span>}
                        </div>
                        <div className='vr-set-plan-summary'>
                            <p className='manage-sub-heading vr-set-plan-label'>Current Plan</p>
                            {(subscribeUserDetails?.period === null || subscribeUserDetails?.period === "N/A") &&
                                (subscribeUserDetails?.productId !== null && subscribeUserDetails?.productId !== "N/A") ? (
                                <p className='manage-sub-heading vr-set-plan-price'>
                                    <span>{price}</span> - {billingCycle}

                                </p>
                            ) : (
                                <p className='manage-sub-heading vr-set-plan-price'>
                                    <span>{price}</span> for 1 {planTitle}
                                </p>
                            )}
                        </div>
                    </div>
                    <div className='vr-set-plan-body'>
                        <p className='manage-sub-heading vr-set-plan-label'>Included in Plan</p>
                        <ul className='vr-set-benefits'>

                            {features.map((feature, index) => (
                                <li key={index}>
                                    <span className='vr-set-check'><Icon icon="lucide:check" width="13" height="13" /></span>
                                    {feature}
                                </li>
                            ))}
                        </ul>
                    </div>

                    {isPlanActive ? (
                        <div className='vr-set-plan-foot'>
                            <hr />
                            {
                                (subscribeUserDetails?.productId === null || subscribeUserDetails?.productId === "N/A") &&
                                    (subscribeUserDetails?.period !== null || subscribeUserDetails?.period !== "N/A") ? (
                                    <>
                                        <button
                                            onClick={() => {
                                                setOpenModal(true)
                                            }
                                            }
                                            // disabled={subscribeUserDetails?.period !== null || 'N/A'}
                                            disabled={
                                                (subscribeUserDetails?.productId === null || subscribeUserDetails?.productId === "N/A") &&
                                                (subscribeUserDetails?.period !== null || subscribeUserDetails?.period !== "N/A")
                                            }
                                            className={`vr-set-cancel ${((subscribeUserDetails?.productId === null || subscribeUserDetails?.productId === "N/A") &&
                                                (subscribeUserDetails?.period !== null || subscribeUserDetails?.period !== "N/A")) ? 'is-disabled' : ''}`}>
                                            Cancel Plan
                                        </button>
                                    </>
                                ) : (
                                    <div className='vr-set-plan-note'>
                                        <span className='vr-set-plan-note-icon'><Icon icon="lucide:smartphone" width="18" height="18" /></span>
                                        <p>
                                            <span>Subscribed via Mobile app</span>
                                            Manage subscription and view invoices on your mobile device
                                        </p>
                                    </div>
                                )
                            }
                        </div>
                    ) : ''}

                </div>

                {opnenModal && (
                    <Modal
                        onClose={(e) => setOpenModal(false)}
                        modaltxt={subscribeUserDetails?.productId != null ? "Cancel Subscription" : "Cancel Plan"}
                    >
                        {subscribeUserDetails?.productId != null ? (
                            <div>
                                <div className="form-group mb-4 vr-set-modal-copy">
                                    {/* <h4 style={{ display: "flex", alignItems: 'center', justifyContent: 'center' }}>Cancel Subscription</h4> */}
                                    <p className='manage-sub-heading'>This subscription is managed through your original purchase platform. Please manage your subscription from your device settings.</p>
                                    <p className='manage-sub-heading'>Contact support if you need assistance.</p>
                                </div>
                                <button
                                    type="button"
                                    // className="btn"
                                    className="vr-btn vr-btn-primary vr-btn-lg vr-btn-block"
                                    onClick={() => openWidget()
                                        // navigate('/support')
                                    }
                                >
                                    Contact Support
                                </button>
                            </div>
                        ) : (
                            <div>
                                <div className="form-group mb-4 vr-set-modal-copy">
                                    <p className='manage-sub-heading'>Are you sure you want to cancel your subscription? By canceling, you may lose access to premium features and benefits. This action cannot be undone.</p>
                                </div>
                                <div className="form-group vr-set-modal-actions">
                                    <button
                                        type="button"
                                        className="vr-btn vr-btn-secondary"
                                        onClick={() => setOpenModal(false)}
                                    >
                                        Discard Cancellation
                                    </button>
                                    <button
                                        type="button"
                                        className="vr-btn vr-set-btn-danger"
                                        onClick={(e) => handleCancelSubscription(e)}
                                    >


                                        {loading ? (
                                            <>
                                                <span style={{ marginRight: '10px' }}>Cancelling</span>
                                                <div
                                                    className="spinner-border vr-set-spin"
                                                    role="status"
                                                >
                                                    <span className="visually-hidden">Loading...</span>
                                                </div>
                                            </>
                                        ) : (
                                            <>
                                                <span>
                                                    Confirm & Cancel
                                                </span>
                                            </>
                                        )
                                        }
                                    </button>
                                </div>
                            </div>
                        )}
                    </Modal>
                )}



                {
                    (
                        subscribeUserDetails?.isSubscriptionActive &&
                        !subscribeUserDetails?.isExpired &&
                        !subscribeUserDetails?.isCancelSubscription
                    ) &&
                        (
                            (subscribeUserDetails?.period === "N/A" || subscribeUserDetails?.period === null) &&
                            (subscribeUserDetails?.productId !== null && subscribeUserDetails?.productId !== "N/A")
                        )
                        ?
                        (<>
                            <div className='vr-set-card'>
                                <h3 className='vr-set-card-title'>
                                    Billing Details
                                </h3>
                                <div className='vr-set-billing'>
                                    {/* Next Payment */}
                                    <div className='vr-set-stat'>
                                        <p className='vr-set-stat-label'>{user?.hasSubscribe}Next Payment</p>
                                        <p className='manage-sub-heading'>{formattedExpireDate}</p>
                                    </div>
                                    {/* Billing Cycle */}
                                    <div className='vr-set-stat'>
                                        <p className='vr-set-stat-label'>Billing Cycle</p>
                                        <p className='manage-sub-heading'>{billingCycle}</p>
                                    </div>

                                </div>
                            </div>
                        </>) : null
                }
            </div >
        </>

    )


}

export default ManagePlan
